export const daCopy = {
  nav: {
    home: 'Forside',
    properties: 'Ejendomme',
    availableUnits: 'Ledige lejemål',
    tenantInfo: 'Lejerinformation',
    contact: 'Kontakt',
  },
  cta: {
    viewAvailableUnits: 'Se ledige lejemål',
    contactUs: 'Kontakt os',
    signUp: 'Skriv dig op',
    backToProperties: 'Tilbage til ejendomme',
  },
  form: {
    labels: {
      name: 'Navn',
      email: 'E-mail',
      phone: 'Telefonnummer',
      rooms: 'Antal værelser',
      rent: 'Månedlig husleje',
      interest: 'Interesseret indtil',
    },
    placeholders: {
      name: 'Dit fulde navn',
      email: 'navn@eksempel.dk',
      phone: 'Fx 40 30 34 35',
      rooms: 'Vælg antal værelser',
      rent: 'DKK',
    },
    errors: {
      nameRequired: 'Indtast dit navn.',
      emailInvalid: 'Indtast en gyldig e-mailadresse.',
      emailRequired: 'Indtast din e-mailadresse.',
      phoneInvalid: 'Indtast et gyldigt telefonnummer.',
      phoneRequired: 'Indtast dit telefonnummer.',
      roomsRequired: 'Vælg antal værelser.',
      rentInvalid: 'Indtast en gyldig husleje.',
      rentRequired: 'Indtast ønsket husleje.',
      interestInvalid: 'Vælg en gyldig dato.',
      interestRequired: 'Vælg en dato.',
      genericSubmit: 'Noget gik galt. Prøv igen om lidt.',
    },
    success: 'Tak – du er nu skrevet op.',
    submit: 'Send',
  },
  status: {
    loading: 'Indlæser ...',
  },
} as const;

export type DaCopy = typeof daCopy;
